/**
 * フォーマットユーティリティ（docs/pm/CONTRACTS.md §4）
 */

/** 円の整数金額を '¥12,345' 形式の文字列に変換する（負数は '-¥1,234' 形式） */
export function formatCurrencyJPY(amount: number): string {
  const rounded = Math.round(amount);
  const sign = rounded < 0 ? '-' : '';
  return `${sign}¥${Math.abs(rounded).toLocaleString('ja-JP')}`;
}
